import { createFileRoute } from "@tanstack/react-router";
import OliviaSierra from "@/pages/OliviaSierra";
export const Route = createFileRoute("/olivia-sierra")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Olivia Sierra, LCSW | Primary Therapist | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Olivia Sierra shares her story of depression recovery with TMS at Neuro Wellness TMS in Coral Springs, FL. Read her patient experience Free consultation.",
        },
        {
          property: "og:title",
          content:
            "Olivia Sierra, LCSW | Primary Therapist | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Olivia Sierra shares her story of depression recovery with TMS at Neuro Wellness TMS in Coral Springs, FL. Read her patient experience Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/olivia-sierra",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/olivia-sierra",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <OliviaSierra />;
}
